import React from 'react';

export const NewSocialIcon = (props) => {
  const { className = '', style = {}, onClick, disabled = false } = props;
  return (
    <svg
      className={`custom-icon ${disabled ? 'disabled' : ''} ${className}`}
      onClick={disabled ? null : onClick}
      style={style}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M17.7491 17.8662H30.0157V19.3959H17.7491V17.8662Z" />
      <path d="M30.0157 20.9404H17.7491V22.4701H30.0157V20.9404Z" />
      <path d="M17.7491 23.9998H25.4121V25.5295H17.7491V23.9998Z" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.2631 11.7334H34.7371C35.5754 11.7334 36.2667 12.4247 36.2667 13.2631V30.1334C36.2667 30.9718 35.5754 31.6631 34.7371 31.6631H24.1913L17.8667 36.2667V31.6631H13.2631C12.4247 31.6631 11.7334 30.9718 11.7334 30.1334V13.2631C11.7334 12.4247 12.4247 11.7334 13.2631 11.7334ZM14.1308 29.1332H33.884L33.8693 14.3368H14.1308V29.1332Z"
      />
    </svg>
  );
};

// Figma: new event
